import { Grid, Typography } from '@mui/material'
import { industries } from '@/content/site'
import { industriesCopy } from '@/content/copy'
import { industryIcons } from '@/lib/icons'
import { layout } from '@/theme'
import { Section } from '@/components/ui/Section'
import { Eyebrow } from '@/components/ui/Eyebrow'
import { Breadcrumbs } from '@/components/ui/Breadcrumbs'
import { IndustryCard } from '@/components/cards/IndustryCard'
import { ContactCTA } from '@/components/sections/ContactCTA'
import { Seo } from '@/components/seo/Seo'

export function Industries() {
  return (
    <>
      <Seo title="Industries We Serve" path="/industries" description="True Forge safety equipment for welding, steel, oil & gas, construction, mining and more." />

      <Section sx={{ pb: 0 }}>
        <Breadcrumbs items={[{ label: 'Home', to: '/' }, { label: 'Industries' }]} />
        <Eyebrow>{industriesCopy.eyebrow}</Eyebrow>
        <Typography variant="h1" component="h1" sx={{ maxWidth: 940 }}>
          {industriesCopy.title}
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary', mt: 3, maxWidth: layout.contentMaxWidth }}>
          {industriesCopy.lede}
        </Typography>
      </Section>

      <Section>
        <Grid container spacing={{ xs: 2.5, md: 3 }}>
          {industries.map((industry) => (
            <Grid key={industry.slug} size={{ xs: 6, sm: 4, md: 3 }}>
              <IndustryCard icon={industryIcons[industry.slug]} name={industry.name} to={`/industries/${industry.slug}`} />
            </Grid>
          ))}
        </Grid>
      </Section>

      <ContactCTA />
    </>
  )
}
